export default () => {
    return {
        mounted() {
            this.intro();
            this.parallax();
        },

        intro() {
            const delay = this.$store.enterDelay;

            const flood = gsap.timeline({
                delay: delay,
                onComplete: () => {
                    this.blob();
                }
            });

            flood
                .fromTo(this.$refs.blob, { xPercent: -50 }, { xPercent: 0, duration: 0.3, ease: 'quad.out' })
                .to(this.$refs.drop, { morphSVG: this.$refs.wave, duration: 1.2, ease: 'circ.inOut' }, '<');

            const header = gsap.timeline({
                delay: delay + 0.6
            });

            header
                .fromTo(this.$refs.logomark, { opacity: 0 }, { duration: 0.3, opacity: 1 })
                .fromTo(this.$refs.logotext01, { opacity: 0 }, { duration: 0.3, opacity: 1 }, '<0.2')
                .fromTo(this.$refs.logotext02, { opacity: 0 }, { duration: 0.3, opacity: 1 }, '<0.15');

            if (this.$refs.topoSpin) {
                gsap.to(this.$refs.topoSpin, {
                    duration: 25,
                    rotate: 360,
                    transformOrigin: '30% 70%',
                    repeat: -1,
                    ease: 'none'
                });
            }
        },

        blob() {
            const morph = gsap.timeline({
                repeat: -1,
                yoyo: true,
                defaults: {
                    ease: 'power1.inOut'
                }
            });

            morph
                .to(this.$refs.drop, { morphSVG: this.$refs.wave02, duration: 6 })
                .to(this.$refs.drop, { morphSVG: this.$refs.wave03, duration: 4 })
                .to(this.$refs.drop, { morphSVG: this.$refs.wave, duration: 5 });
        },

        parallax() {
            const parallax = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.hero,
                    scrub: 0.8,
                    start: 'top top',
                    end: 'bottom top'
                }
            });

            if (this.$refs.dots) {
                parallax.fromTo(
                    this.$refs.dots,
                    {
                        yPercent: 0
                    },
                    {
                        yPercent: 60,
                        ease: 'none'
                    }
                );
            }

            if (this.$refs.topo) {
                parallax.fromTo(
                    this.$refs.topo,
                    {
                        yPercent: 0
                    },
                    {
                        yPercent: -60,
                        ease: 'none'
                    },
                    '<0'
                );
            }

            if (this.$refs.content) {
                parallax.fromTo(
                    this.$refs.content,
                    {
                        yPercent: 0
                    },
                    {
                        yPercent: -40,
                        ease: 'none'
                    },
                    '<0'
                );
            }
        }
    };
};
